module.exports = "//docs.gtimg.com/slide/img/framework/editor/src/img/pageIndex/spinner-6b57d0.svg";